export const POST_PAGE_RESIZE = 'postPage/RESIZE';

export const postPageResized = (payload) => ({
  type: POST_PAGE_RESIZE,
  payload,
  meta: { debounce: 2000 },
});
